import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownList, Button } from '@contentful/ui-component-library';

class EntryEmbedDropdown extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    isOpen: PropTypes.bool,
    disabled: PropTypes.bool,
    onClose: PropTypes.func,
    onToggle: PropTypes.func,
    change: PropTypes.object
  };

  render() {
    const { onToggle, isOpen, onClose, children } = this.props;
    return (
      <Dropdown
        extraClassNames="toolbar-entry-dropdown"
        position="bottom-right"
        toggleElement={
          <Button
            onMouseDown={onToggle}
            data-test-id="toolbar-entry-dropdown-toggle"
            extraClassNames="toolbar-entry-dropdown-toggle"
            indicateDropdown
            buttonType="muted"
            icon="Entry"
            size="small"
            disabled={this.props.disabled}>
            Embed Entry
          </Button>
        }
        isOpen={isOpen}
        onClose={onClose}>
        <DropdownList extraClassNames="toolbar-entry-dropdown-list">{children}</DropdownList>
      </Dropdown>
    );
  }
}

export default EntryEmbedDropdown;



// WEBPACK FOOTER //
// ./src/javascripts/app/widgets/structured_text/plugins/EntryEmbedDropdown/index.es6.js